<template>
  <v-container>
    <v-row justify="space-between">
      <v-col cols="auto">
        <h1>课程管理</h1>
      </v-col>
      <v-col cols="auto" align-self="center">
        <v-btn color="primary" @click="showCreateCourseTopicDialog()">
          新增课程主题
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col cols="4">
        <v-select
          v-model="selectedCategory"
          :items="categories"
          item-text="name"
          item-value="categoryId"
          label="选择课程分类"
          clearable
          @change="handleCategorySelect"
        ></v-select>
      </v-col>
    </v-row>
    
    <v-row class="mb-4">
      <v-col cols="auto" align-self="center" class="pr-0">
        <span class="grey--text">已选择：</span>
      </v-col>
      <v-col>
        <v-chip
          v-for="category in selectedCategories"
          :key="category.categoryId"
          class="ma-1"
          close
          color="primary"
          @click:close="removeCategory(category)"
        >
          {{ category.name }}
        </v-chip>
        <span v-if="selectedCategories.length === 0" class="grey--text">
          尚未选择任何分类
        </span>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="courseTopics"
      :items-per-page="20"
      :loading="loading"
      class="elevation-1"
    >
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon small @click="showCourseDetailDialog(item)" color="blue">mdi-pencil</v-icon>
        <v-icon small @click="showDeleteCourseConfirm(item)" color="red">mdi-delete</v-icon>
      </template>
    </v-data-table>

    <create-course-topic-popup
      ref="createCourseTopicPopup"
      @course-topic-created="handleCourseTopicCreated"
    ></create-course-topic-popup>
    <course-topic-detail-popup
      ref="courseTopicDetailPopup"
      :item="selectedCourseTopic"
      @update-course="updateCourse"
    ></course-topic-detail-popup>
    <delete-course-topic-confirmation
      ref="deleteCourseTopicConfirmation"
      :item="selectedCourseTopic"
      @course-deleted="handleCourseDeleted"
    ></delete-course-topic-confirmation>
  </v-container>
</template>

<script>
import { courseApi } from '@/api/course'

export default {
  components: {
    CreateCourseTopicPopup: () => import('@/components/CreateCourseTopicPopup.vue'),
    CourseTopicDetailPopup: () => import('@/components/CourseTopicDetailPopup.vue'),
    DeleteCourseTopicConfirmation: () => import('@/components/DeleteCourseTopicConfirmation.vue')
  },
  created() {
    this.fetchCategories();
    this.fetchCourseTopicList();
  },
  data() {
    return {
      headers: [
        // { text: "课程图片", value: "coverImageUrl" },
        { text: "课程ID", value: "courseTopicId" },
        { text: "课程主题", value: "courseTopicName" },
        { text: "更新时间", value: "lastModifiedTime" },
        { text: "创建时间", value: "createdTime" },
        { text: "操作", value: "actions", sortable: false }
      ],
      courseTopics: [],
      selectedCourseTopic: null,
      categories: [],
      selectedCategory: null,
      selectedCategories: [],
      loading: false,
    }
  },
  methods: {
    showCreateCourseTopicDialog() {
      this.$refs.createCourseTopicPopup.open(this.categories);
    },
    showCourseDetailDialog(item) {
      this.selectedCourseTopic = item;
      this.$refs.courseTopicDetailPopup.open(item);
    },
    showDeleteCourseConfirm(item) {
      this.selectedCourseTopic = item;
      this.$refs.deleteCourseTopicConfirmation.open(item);
    },
    removeCategory(category) {
      const index = this.selectedCategories.findIndex(c => c.categoryId === category.categoryId);
      if (index > -1) {
        this.selectedCategories.splice(index, 1);
        this.fetchCourseTopicList();
      }
    },
    async updateCourse() {
      // 更新表格中的数据
      // const index = this.courses.findIndex(course => course.id === item.id);
      // if (index !== -1) {
      //   this.courses.splice(index, 1, item);
      // }
      this.fetchCourseTopicList();
    },
    deleteCourse(item) {
      console.log(item);
    },
    showCreateCourseDialog() {
      this.$refs.createCoursePopup.open();
    },
    handleCategorySelect(categoryId) {
      if (!categoryId) return
      
      const category = this.categories.find(c => c.categoryId === categoryId);
      if (category && !this.selectedCategories.some(c => c.categoryId === category.categoryId)) {
        this.selectedCategories.push(category);
        this.fetchCourseTopicList();
      }
      this.selectedCategory = null;
    },
    handleCourseTopicCreated(newCourseTopic) {
      if (newCourseTopic) {
        console.log('newCourseTopic = ', newCourseTopic);
        this.courseTopics.push(newCourseTopic);
        this.fetchCourseTopicList();
      }
    },
    async fetchCourseTopicList() {
      this.loading = true;
      try {
        const categoryIds = this.selectedCategories.map(c => c.categoryId);
        const response = await courseApi.getCourseTopicList({
          categoryIds: categoryIds
        });
        console.log('fetchCourseTopicList resp = ', response);
        this.courseTopics = response.data.courseTopics;
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取课程列表失败：' + errorMessage)
      } finally {
        this.loading = false
      }
    },
    async fetchCategories() {
      try {
        const response = await courseApi.getCourseCategories();
        console.log('categories response = ' , response);
        this.categories = response.data.map(category => ({
          ...category,
          id: category.categoryId,
          name: category.name
        }));
        console.log('this.categories = ' , this.categories);
      } catch (error) {
        const errorMessage = error.response?.data?.message || error.message || '未知错误';
        this.$toast.error('获取分类列表失败：' + errorMessage)
      }
    },
    handleCourseDeleted() {
      console.log('刪除課程主題成功，刷新列表');
      this.fetchCourseTopicList();
    }
  }
};
</script>

<style scoped>
.v-chip {
  margin-right: 8px;
}
</style>